import React from "react";
import Anchor from "../../HTMLEntities/Anchor";
import {
    FooterLastBottomLeftPart,
    FooterLastBottomRightPart,
    FooterLastBottomSection,
} from "./FooterStyled";
import PropTypes from "prop-types";

const FooterCopyright = (props) => {
    const {isMobile} = props;
    const currentYearNew = new Date().getFullYear();
    return (
        <FooterLastBottomSection>
            <FooterLastBottomLeftPart>
                <ul>
                    <li>
                        <Anchor
                            linkHref={"https://www.shiksha.com/shikshaHelp/ShikshaHelp/grievances"}
                            displayStyle={{
                                mobile: {},
                                laptop: {
                                    width: "auto",
                                    maxWidth: "100%",
                                },
                            }}
                        >
                            Grievances
                        </Anchor>
                    </li>
                    <li>
                        <Anchor
                            linkHref={
                                "https://www.shiksha.com/shikshaHelp/ShikshaHelp/summonsNotices"
                            }
                            displayStyle={{
                                mobile: {},
                                laptop: {
                                    width: "auto",
                                    maxWidth: "100%",
                                },
                            }}
                        >
                            Notices / Summons
                        </Anchor>
                    </li>
                    <li>
                        <Anchor
                            linkHref={
                                "https://www.shiksha.com/shikshaHelp/ShikshaHelp/privacyPolicy"
                            }
                            displayStyle={{
                                mobile: {},
                                laptop: {
                                    width: "auto",
                                    maxWidth: "100%",
                                },
                            }}
                        >
                            Privacy
                        </Anchor>
                    </li>
                    {/* <li>
                        <Anchor
                            linkHref={
                                "https://www.shiksha.com/shikshaHelp/ShikshaHelp/grievances"
                            }
                            displayStyle={{
                                mobile: {},
                                laptop: {
                                    width: "auto",
                                    maxWidth: "100%",
                                },
                            }}
                        >
                            Sitemap
                        </Anchor>
                    </li> */}
                    <li>
                        <Anchor
                            linkHref={
                                "https://www.shiksha.com/shikshaHelp/ShikshaHelp/termCondition"
                            }
                            displayStyle={{
                                mobile: {
                                    width: "100%",
                                    maxWidth: "100%",
                                },
                                laptop: {
                                    width: "auto",
                                    maxWidth: "100%",
                                },
                            }}
                        >
                            Terms &amp; Conditions
                        </Anchor>
                    </li>
                </ul>
            </FooterLastBottomLeftPart>
            <FooterLastBottomRightPart>
                {!isMobile && (
                    <>
                        All trademarks belong to the respective owners. Copyright © {currentYearNew}{" "}
                        Info Edge India Ltd, All rights reserved.
                    </>
                )}
                {isMobile && (
                    <>
                        All trademarks belong to the respective owners.
                        <br />
                        Copyright © {currentYearNew} Info Edge India Ltd, All rights reserved.
                    </>
                )}
            </FooterLastBottomRightPart>
        </FooterLastBottomSection>
    );
};

FooterCopyright.propTypes = {
    isMobile: PropTypes.bool,
};

export default FooterCopyright;
